import { api } from './api';

export type ClarityDeploymentRow = {
  deployment_id: string;
  config_type: 'policies' | 'zones' | 'drb' | string;
  org_id?: string;
  site_id?: string;
  edge_device_id: string;
  bundle_version?: number | null;
  bundle_hash?: string | null;
  status?: string | null;
  created_at?: string | null;
  published_at?: string | null;
  acked_at?: string | null;
  nacked_at?: string | null;
  timeout_at?: string | null;
  camera_id?: string | null;
  error?: any;
  payload?: any;
};

export const runtimeBlueprintsApi = {
  async edgeHealth(deviceId: string): Promise<any> {
    const r = await api.get(`/api/v1/pipeline/devices/${encodeURIComponent(deviceId)}/edge/health`);
    return r.data;
  },

  async edgeRuntimeStatus(deviceId: string, cameras?: string[]): Promise<any> {
    const cams = (cameras || []).filter((x) => (x || '').trim()).join(',');
    const r = await api.get(`/api/v1/pipeline/devices/${encodeURIComponent(deviceId)}/edge/runtime/status`, {
      params: { cameras: cams || undefined },
    });
    return r.data;
  },

  async edgeBlueprints(
    deviceId: string,
    includeContentOrOpts:
      | boolean
      | {
          includeContent?: boolean;
          cameras?: string[];
          includeHashes?: boolean;
          redactNetwork?: boolean;
          maxTotalBytes?: number;
        } = false,
  ): Promise<any> {
    const opts =
      typeof includeContentOrOpts === 'boolean'
        ? { includeContent: includeContentOrOpts }
        : (includeContentOrOpts ?? { includeContent: false });

    const cameras = (opts.cameras || []).filter((x) => (x || '').trim()).join(',');
    const r = await api.get(`/api/v1/pipeline/devices/${encodeURIComponent(deviceId)}/edge/blueprints`, {
      params: {
        include_content: opts.includeContent ? 'true' : 'false',
        include_hashes: opts.includeHashes ? 'true' : 'false',
        redact_network: opts.redactNetwork === false ? 'false' : 'true',
        max_total_bytes: opts.maxTotalBytes ?? undefined,
        cameras: cameras || undefined,
      },
    });
    return r.data;
  },

  async drbStatus(deviceId: string): Promise<any> {
    const r = await api.get(`/api/v1/devices/${encodeURIComponent(deviceId)}/drb`);
    return r.data;
  },

  async listClarityDeployments(params: {
    edge_device_id?: string;
    config_type?: string;
    status?: string;
    limit?: number;
    offset?: number;
    include_payload?: boolean;
  }): Promise<{ deployments: ClarityDeploymentRow[]; limit: number; offset: number; count: number }> {
    const r = await api.get(`/api/v1/deployments/clarity/deployments`, { params });
    return r.data;
  },

  async republishClarity(req: {
    edge_device_id: string;
    config_type: 'policies' | 'zones' | 'drb' | 'fcp';
    camera_id?: string;
  }): Promise<any> {
    const r = await api.post(`/api/v1/deployments/clarity/republish`, req);
    return r.data;
  },

  /** Republish zones for all cameras (zones are per-camera; single republish only covers one). */
  async republishZonesAll(edge_device_id: string): Promise<any> {
    const r = await api.post(`/api/v1/deployments/clarity/republish_zones_all`, { edge_device_id });
    return r.data;
  },
};

export default runtimeBlueprintsApi;

